import React from "react";
import { getIBSCBSList, createIBSCBS, updateIBSCBS } from "../../../../api/products/taxes";
import LoadingContainer from "../../../../_components/LoadingContainer";
import LoadingInput from "../../../../_components/LoadingInput";
import CurrencyInput from "react-currency-input";
import Button from "../../../../_components/Button";
import Modal from "../../../../_components/Modal";
import Text from "../../../../_components/Text";
import TableData from "../../../../_components/TableData";
import { showSnackBar } from "../../../../utils";
import DeleteIBSCBS from "./DeleteIBSCBS";
import { Select } from "../../../../design-system";
import { MOCK_DATA } from "../../../../_components/IBSCBSClassificationSelector";

const MAX_TEMPLATES = 3;

// CST options for IBS/CBS (Reforma Tributária)
const IBS_CBS_CST = [
    { value: "000", label: "000 - Tributação integral" },
    { value: "010", label: "010 - Tributação com alíquotas uniformes" },
    { value: "011", label: "011 - Tributação com alíquotas uniformes reduzidas" },
    { value: "200", label: "200 - Alíquota reduzida" },
    { value: "220", label: "220 - Alíquota fixa" },
    { value: "222", label: "222 - Redução de base de cálculo" },
    { value: "221", label: "221 - Alíquota fixa proporcional" },
    { value: "400", label: "400 - Isenção" },
    { value: "410", label: "410 - Imunidade e não incidência" },
    { value: "510", label: "510 - Diferimento" },
    { value: "515", label: "515 - Diferimento com redução de alíquota" },
    { value: "550", label: "550 - Suspensão" },
    { value: "620", label: "620 - Tributação monofásica" },
    { value: "800", label: "800 - Transferência de crédito" },
    { value: "810", label: "810 - Ajuste de IBS na ZFM" },
    { value: "811", label: "811 - Ajustes" },
    { value: "820", label: "820 - Tributação em declaração de regime específico" },
    { value: "830", label: "830 - Exclusão de base de cálculo" },
];

const DEFAULT_TEMPLATE = {
    name: "IBS/CBS Padrão",
    cst: "000",
    p_ibs: 0.1,
    p_cbs: 0.9
};

export default props => {
    const [loading, setLoading] = React.useState(false)
    const [data, setData] = React.useState([])
    const [ibscbs, setIBSCBS] = React.useState({})

    function onSave() {
        setTimeout(() => window.location.reload(), 1500)
    }

    function init() {
        setLoading(true)
        getIBSCBSList()
            .then(resp => {
                const mapped = resp.map(item => {
                    var cstEntry = IBS_CBS_CST.find(function(c) { return c.value === item.cst })
                    var cst_label = (cstEntry && cstEntry.label) ? cstEntry.label : (item.cst || "-")
                    var p_ibs_label = (item.p_ibs !== null && item.p_ibs !== undefined) ? (item.p_ibs + " %") : "-"
                    var p_cbs_label = (item.p_cbs !== null && item.p_cbs !== undefined) ? (item.p_cbs + " %") : "-"
                    return Object.assign({}, item, {
                        cst_label: cst_label,
                        p_ibs_label: p_ibs_label,
                        p_cbs_label: p_cbs_label,
                        edit: (
                            <div className="d-flex gap-2">
                                <Button onClick={() => setIBSCBS(item)} as="text">
                                    <i className="fas fa-edit"></i>
                                </Button>
                                <DeleteIBSCBS id={item.id} title={item.name} />
                            </div>
                        )
                    })
                })
                setData(mapped)
            })
            .finally(() => setLoading(false))
    }

    React.useEffect(init, [])

    const atLimit = data.length >= MAX_TEMPLATES

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 py-3">
                    <Text className="text-center" as="h1">
                        Modelos de IBS/CBS
                    </Text>
                    <div className="d-flex justify-content-center my-3">
                        <Template
                            atLimit={atLimit}
                            currentCount={data.length}
                            onSave={onSave}
                            data={ibscbs}
                            allTemplates={data}
                        />
                    </div>

                    {atLimit && (
                        <div className="alert alert-warning text-center mx-auto" style={{ maxWidth: 560 }}>
                            <i className="fas fa-lock mr-2"></i>
                            Limite de <strong>{MAX_TEMPLATES} modelos</strong> atingido. Exclua um modelo para criar um novo.
                        </div>
                    )}

                    {data.length > 0
                        ? (
                            <LoadingContainer loading={loading}>
                                <TableData
                                    data={data}
                                    tHead={["Nome", "CST", "Alíquota IBS (%)", "Alíquota CBS (%)", "Ações"]}
                                    tBodyKeys={["name", "cst_label", "p_ibs_label", "p_cbs_label", "edit"]}
                                />
                            </LoadingContainer>
                        )
                        : <React.Fragment />
                    }
                </div>
            </div>
        </div>
    )
}

export function Template(props) {
    const [show, setShow] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const [template, setTemplateData] = React.useState(DEFAULT_TEMPLATE)

    function onChange({ target }) {
        const { name: key, value } = target
        setTemplateData({ ...template, [key]: value })
    }

    function onHide() {
        setTemplateData(DEFAULT_TEMPLATE)
        setShow(false)
    }

    function onSubmit() {
        if (!template.name) {
            showSnackBar("Informe o nome do modelo")
            return
        }

        const nameExists = props.allTemplates && props.allTemplates.find(t => 
            t.name.trim().toLowerCase() === template.name.trim().toLowerCase() && t.id !== template.id
        )

        if (nameExists) {
            showSnackBar("Já existe um modelo cadastrado com este nome")
            return
        }
        if (!template.cst) {
            showSnackBar("Selecione o CST do IBS/CBS")
            return
        }
        if (template.p_ibs === undefined || template.p_ibs === "") {
            showSnackBar("Informe a alíquota do IBS")
            return
        }
        if (template.p_cbs === undefined || template.p_cbs === "") {
            showSnackBar("Informe a alíquota do CBS")
            return
        }
        if (template.classificacao_codigo && template._classificacao_invalid) {
            showSnackBar("O código da Classificação Tributária informado é inválido")
            return
        }

        const request = template.id ? updateIBSCBS : createIBSCBS

        setLoading(true)
        request(template)
            .then(result => {
                showSnackBar("Modelo de IBS/CBS salvo com sucesso!", "info")
                if (!props.onSave) {
                    setTimeout(() => window.location.reload(), 1500)
                } else {
                    props.onSave(result)
                }
            })
            .finally(() => {
                setTimeout(() => {
                    setLoading(false)
                    if (props.onClear) {
                        setShow(false)
                        setTemplateData(DEFAULT_TEMPLATE)
                    }
                }, 2000)
            })
    }

    // Open in edit mode when parent passes a filled `data` prop
    function edit() {
        if (props.data && props.data.id) {
            setTemplateData({ ...props.data })
            setShow(true)
        }
    }
    React.useEffect(edit, [props.data])

    const isEditing = !!(template && template.id)

    const cstOptions = React.useMemo(() => {
        return MOCK_DATA.map(item => ({
            value: item.cst,
            label: `${item.cst} - ${item.descricao}`
        }));
    }, []);

    const classificacaoOptions = React.useMemo(() => {
        const group = MOCK_DATA.find(item => item.cst === template.cst);
        if (!group) return [];
        return group.classificacoes.map(c => ({
            value: c.codigo,
            label: `${c.codigo} - ${c.descricaoReduzida}`
        }));
    }, [template.cst]);

    React.useEffect(() => {
        if (!template.classificacao_codigo && classificacaoOptions.length > 0) {
            const first = classificacaoOptions[0];
            const desc = first.label.split(" - ").slice(1).join(" - ");
            setTemplateData(prev => ({
                ...prev,
                classificacao_codigo: first.value,
                classificacao_descricao: desc,
                _classificacao_invalid: false
            }));
        }
    }, [classificacaoOptions, template.classificacao_codigo]);

    return (
        <div>
            <Button
                as="text"
                onClick={() => {
                    if (!isEditing) setTemplateData(DEFAULT_TEMPLATE)
                    setShow(true)
                }}
                disabled={props.atLimit && !isEditing}
                title={props.atLimit && !isEditing ? "Limite de 3 modelos atingido" : undefined}
            >
                {isEditing ? "Editar modelo" : (props.buttonText || "Criar novo modelo")}
            </Button>

            <Modal show={show} title={isEditing ? "Editar modelo de IBS/CBS" : "Cadastrar modelo de IBS/CBS"} onHide={onHide}>
                <div className="container">

                    {/* Limit disclaimer when creating */}
                    {!isEditing && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="alert alert-info mb-0">
                                    <i className="fas fa-info-circle mr-2"></i>
                                    Você pode cadastrar até <strong>3 modelos</strong> de IBS/CBS.
                                    {props.currentCount !== undefined && (
                                        <span className="ml-1">
                                            Cadastrados: <strong>{props.currentCount}/3</strong>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="row">
                        {/* Name */}
                        <div className="col-12">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>Nome / Descrição do modelo</Text>
                                </div>
                                <LoadingInput
                                    loading={loading}
                                    required
                                    name="name"
                                    placeholder="Ex: IBS/CBS Padrão"
                                    onChange={onChange}
                                    value={template.name || ""}
                                />
                            </div>
                        </div>

                        {/* p_ibs */}
                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>Alíquota do IBS (%)</Text>
                                </div>
                                <CurrencyInput
                                    disabled={loading}
                                    required
                                    name="p_ibs"
                                    value={template.p_ibs}
                                    onChange={(e, value) => onChange({ target: { name: "p_ibs", value } })}
                                    suffix=" %"
                                    className="form-control"
                                    placeholder="0,00 %"
                                />
                            </div>
                        </div>

                        {/* p_cbs */}
                        <div className="col-md-6">
                            <div className="form-group">
                                <div className="form-label">
                                    <Text>Alíquota do CBS (%)</Text>
                                </div>
                                <CurrencyInput
                                    disabled={loading}
                                    required
                                    name="p_cbs"
                                    value={template.p_cbs}
                                    onChange={(e, value) => onChange({ target: { name: "p_cbs", value } })}
                                    suffix=" %"
                                    className="form-control"
                                    placeholder="0,00 %"
                                />
                            </div>
                        </div>

                        {/* CST e Classificação Tributária */}
                        <div className="col-12 mt-2">
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <Select
                                        label="CST IBS/CBS"
                                        options={cstOptions}
                                        value={template.cst}
                                        disabled={loading}
                                        onChange={(e) => {
                                            const selectedCst = e.target.value;
                                            const group = MOCK_DATA.find(g => g.cst === selectedCst);
                                            const firstClassificacao = group && group.classificacoes.length > 0 ? group.classificacoes[0] : null;
                                            
                                            setTemplateData({
                                                ...template,
                                                cst: selectedCst,
                                                classificacao_codigo: firstClassificacao ? firstClassificacao.codigo : "",
                                                classificacao_descricao: firstClassificacao ? firstClassificacao.descricaoReduzida : "",
                                                _classificacao_invalid: false
                                            });
                                        }}
                                    />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <Select
                                        label="Classificação Tributária IBS/CBS"
                                        options={classificacaoOptions}
                                        value={template.classificacao_codigo}
                                        disabled={loading}
                                        onChange={(e) => {
                                            const selectedValue = e.target.value;
                                            const opt = classificacaoOptions.find(o => o.value === selectedValue);
                                            // The label format is "codigo - descricao"
                                            const desc = (opt && opt.label) ? opt.label.split(" - ").slice(1).join(" - ") : "";
                                            setTemplateData({
                                                ...template,
                                                classificacao_codigo: selectedValue,
                                                classificacao_descricao: desc,
                                                _classificacao_invalid: false
                                            });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-2">
                        <div className="col-12">
                            <div className="d-flex justify-content-start">
                                <Button
                                    id="create-ibscbs-template-btn"
                                    onClick={onSubmit}
                                    as="text"
                                    disabled={loading}
                                >
                                    {isEditing ? "Atualizar modelo de IBS/CBS" : "Salvar modelo de IBS/CBS"}
                                </Button>
                            </div>
                        </div>
                    </div>

                </div>
            </Modal>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/IBSCBS/index.jsx